"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductBoxCarouselSkeleton = void 0;
var _presentationComponents = require("@ori/presentation-components");
var _presentationHooks = require("@ori/presentation-hooks");
var _productBox = require("@ori/product-box");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _times = _interopRequireDefault(require("es-toolkit/compat/times"));
var _constants = require("../../constants");
var _utils = require("../../utils");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const ProductBoxCarouselSkeleton = ({
  animation = 'pulse',
  classNames,
  id,
  productCount = _constants.DEFAULT_PRODUCT_BOX_SKELETON_COUNT,
  arrowsMode,
  slider,
  title: titleProp,
  minWidth = 175
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const isMobile = (0, _presentationHooks.useIsMobile)();
  const title = typeof titleProp === 'string' ? titleProp : titleProp?.text;
  const titleProps = typeof titleProp === 'string' ? undefined : titleProp;
  const sliderOptions = (0, _utils.getSliderOptions)({
    slider,
    isMobile
  });
  const spacing = (0, _utils.getSpacingValue)(sliderOptions?.slides);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: classNames?.root,
    "data-testid": getTestId(_constants.PRODUCT_BOX_CAROUSEL_SKELETON),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_presentationComponents.Carousel, {
      className: classNames?.carousel,
      id: id,
      title: {
        text: title,
        ...titleProps
      },
      slider: sliderOptions,
      pagination: {
        show: false
      },
      navigation: {
        position: 'outside',
        showArrows: !isMobile,
        arrowsMode,
        useBreakpointsPerView: true
      },
      children: (0, _times.default)(productCount).map(index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.StyledCarouselSlide, {
        index: index,
        spacing: spacing,
        minWidth: minWidth,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_productBox.ProductBoxSkeleton, {
          animation: animation
        })
      }, index))
    })
  });
};
exports.ProductBoxCarouselSkeleton = ProductBoxCarouselSkeleton;
